import React from "react";
import { connect } from "react-redux";
import { getField, getModel } from "react-redux-form";
import _ from "underscore";

import { getValueAtPath } from "../../../../shared/helpers/objectHelpers";

import "./formProgressIcon.scss";

interface OwnProps {
  model: string;
}

interface StateProps {
  rrfState: Forms.WebFormRoot;
}

const stateToProps = (state: IWebStoreState): StateProps => ({ rrfState: state.forms });

class ProgressIcon extends React.Component<OwnProps & StateProps> {
  public render() {
    const { rrfState, model } = this.props;
    const field = getField(rrfState.forms, model);

    const fieldIsChanged = field != null && !_.isEqual(field.initialValue, getValueAtPath(rrfState.enquiry, model.replace("forms.enquiry", "")));
    const fieldIsValid = fieldIsChanged && field.valid;
    const submitFailed = getField(rrfState.forms, "forms.enquiry").submitFailed;

    if (submitFailed && !fieldIsValid) {
      return (
        <div className="enquire-progress-icon error">
          <div className="icon-wrap">
            <i className="icon icon-question6" />
          </div>
          {this.props.children}
        </div>
      );
    }

    if (fieldIsValid) {
      return (
        <div className="enquire-progress-icon valid">
          <div className="icon-wrap">
            <i className="icon icon-checkmark" />
          </div>
          {this.props.children}
        </div>
      );
    }

    if (fieldIsChanged) {
      return (
        <div className="enquire-progress-icon warn">
          <div className="icon-wrap">
            <i className="icon icon-question6" />
          </div>
          {this.props.children}
        </div>
      );
    }

    return (
      <div className="enquire-progress-icon unknown">
        <div className="icon-wrap">
          <i className="icon icon-question6" aria-hidden="true" />
        </div>
        {this.props.children}
      </div>
    );
  }
}

export const FormProgressIcon = connect<StateProps, {}, OwnProps>(stateToProps)(ProgressIcon);
